export const UPDATE_PROPS = 'UPDATE_PROPS_IN_NOTIFICATIONS';
export const GOT_NOTIFICATIONS = 'GOT_NOTIFICATIONS_FOR_USER';
export const MARKED_READ = 'MARKED_READ_NOTIFICATIONS';



// WEBPACK FOOTER //
// ./src/app/stores/notification/constants.js